import api from './predictAPI'
const fetchShedules = function(params){
    const req = api.instance.get("v1/rounds",{
    params,
    headers: api.getSessionHeaders()
    })
    return req
  }
  const fetchSheduleByID = function(id){
    const req = api.instance.get(`v1/rounds/${id}`, {
    headers: api.getSessionHeaders()
    })
    return req
  }

  const fetchMatchs = function(params){
    const req = api.instance.get("v1/matches",{
    params,
    headers: api.getSessionHeaders()
    })
    return req
  }
  
const sheducleAPI = {
    fetchShedules,
    fetchSheduleByID,
    fetchMatchs

}
export default sheducleAPI 
